import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./FinalCTA.css";

// Section finale : textes validés et un seul CTA vers la page Contact.
const CONTENT = {
  fr: {
    eyebrow: "Passons à la pratique",
    title: "Et si vos ascenseurs devenaient plus simples à gérer ?",
    description: "Découvrez comment les solutions UniTech Engineering peuvent accompagner votre activité.",
    button: "Parlons de votre projet",
    points: [
      "Échanger sur vos besoins",
      "Identifier une solution adaptée",
      "Préparer un premier échange"
    ]
  },
  en: {
    eyebrow: "Let's put ideas into practice",
    title: "What if managing your elevators were simpler?",
    description: "Discover how UniTech Engineering solutions can support your business.",
    button: "Let's talk about your project",
    points: [
      "Discuss your needs",
      "Identify a suitable solution",
      "Prepare an initial conversation"
    ]
  }
};

export default function FinalCTA() {
  const { t, i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "fr")
    .split("-")[0]
    .toLowerCase();
  const fallback = CONTENT[language] || CONTENT.fr;
  const title = t("finalCta.title", { defaultValue: fallback.title });
  const description = t("finalCta.description", { defaultValue: fallback.description });
  const button = t("finalCta.button", { defaultValue: fallback.button });
  const eyebrow = t("finalCta.premium.eyebrow", { defaultValue: fallback.eyebrow });
  const points = fallback.points.map((point, i) =>
    t(`finalCta.premium.points.${i}`, { defaultValue: point })
  );

  return (
    <section className="unitech-final-cta" aria-labelledby="unitech-final-cta-title">
      <div className="unitech-final-cta__container">
        <div className="unitech-final-cta__panel">
          <div className="unitech-final-cta__content">
            <p className="unitech-final-cta__eyebrow">{eyebrow}</p>
            <h2 id="unitech-final-cta-title" className="unitech-final-cta__title">{title}</h2>
            <p className="unitech-final-cta__description">{description}</p>
            <NavLink className="unitech-final-cta__button" to="/contact">
              <span>{button}</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"
                strokeLinejoin="round" aria-hidden="true" focusable="false">
                <path d="M5 19 19 5" />
                <path d="M8 5h11v11" />
              </svg>
            </NavLink>
          </div>
          <div className="unitech-final-cta__aside">
            <ul className="unitech-final-cta__points">
              {points.map((point, index) => (
                <li key={index} className="unitech-final-cta__point">{point}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
